import ServiceCard from '@/components/elements/Card/ServiceCard';
import { LinkButton } from '@/components/elements/forms/buttons';
import { trackMpEvent } from '@/helpers';
import { getGiftcardCheckoutLink, getGiftcardLabel } from '@/helpers/placeHelperTS';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';
import { Place } from '@/types/state/shared';
import { useHistory } from 'react-router-dom';

function trackGiftcardClick(placeId: number) {
  trackMpEvent('buy_gift_card_clicked', {
    screen_name: 'company_details',
    company_id: placeId,
    trigger_source: 'company_details',
  });
}

const baseTranslationKey = 'features.PlacePages.modules.Giftcards';

const Giftcards = ({ place }: { place: Place }) => {
  const history = useHistory();
  const { isMobileView } = useMobileView();
  const giftcardLabel = getGiftcardLabel(place);
  const giftcardLink = getGiftcardCheckoutLink(place);

  const handleRowGiftcardClick = () => {
    trackGiftcardClick(place.id);
    history.push({ pathname: getGiftcardCheckoutLink(place) });
  };

  const handleLinkGiftcardClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    trackGiftcardClick(place.id);
  };

  return (
    <section className="space-y-md">
      <h2 className="text-h-m font-semibold">{_s('GiftCard')}</h2>
      <div className="gap-sm flex flex-col">
        <ServiceCard
          name={giftcardLabel}
          icon="gift-card"
          description={_s(`${baseTranslationKey}.card-description`)}
          price={{ type: 'optional', value: [0] }}
          onRowClick={handleRowGiftcardClick}
          rightSlot={
            <LinkButton
              to={giftcardLink}
              onClick={handleLinkGiftcardClick}
              variant="primary"
              size={isMobileView ? 'md' : 'sm'}
              className="flex max-w-[75px] items-center">
              {isMobileView ? _s('Buy') : _s('BuyNow')}
            </LinkButton>
          }
        />
      </div>
    </section>
  );
};

export default Giftcards;
